import { PopularTreatmentItem } from '@/types/models'

export const POPULAR_TREATMENT_TERM_THRESHOLD_MAP = {
  Executives: 5,
  Wellness: 3,
  Adolescents: 3,
  Detox: 3,
  'Insurance Accepted': 15,
  Christian: 3,
  'Sober Living': 3,
  Outpatient: 3,
  Veterans: 15
}

export const POPULAR_TREATMENT_TAXONOMIES = {
  Outpatient: 'treatment_services',
  Detox: 'treatment_services',
  'Sober Living': 'treatment_services',
  Veterans: 'who_we_treat',
  Adolescents: 'who_we_treat',
  Executives: 'who_we_treat',
  'Insurance Accepted': 'price',
  Christian: 'treatment_methods',
  Wellness: 'treatment_methods'
}

export const POPULAR_TREATMENT_TYPES_DISPLAY_THRESHOLD = 10

export const TERMS_POPULAR_TREATMENT = Object.keys(POPULAR_TREATMENT_TAXONOMIES)

export const popularTreatmentGroupA = [
  {
    label: 'Outpatient',
    slug: '/outpatient/',
    blogImageSlug: 'outpatient-program',
    attribute: 'treatment_services',
    position: 1
  },
  {
    label: 'Detox',
    slug: '/detox/',
    attribute: 'treatment_services',
    position: 2
  },
  {
    label: 'Sober Living',
    slug: '/sober-living/',
    attribute: 'treatment_services',
    position: 3
  }
]

export const popularTreatmentGroupB = [
  {
    label: 'Veterans',
    slug: '/veterans/',
    attribute: 'who_we_treat',
    position: 4
  },
  {
    label: 'Adolescents',
    slug: '/adolescents/',
    attribute: 'who_we_treat',
    position: 5
  },
  {
    label: 'Executives',
    slug: '/executives/',
    attribute: 'who_we_treat',
    position: 6
  }
]

export const popularTreatmentGroupC = [
  {
    label: 'Insurance Accepted',
    slug: '/insurance-accepted/',
    attribute: 'price',
    position: 7
  }
]

export const popularTreatmentGroupD = [
  {
    label: 'Christian',
    slug: '/christian/',
    attribute: 'treatment_methods',
    position: 9
  },
  {
    label: 'Wellness',
    slug: '/wellness/',
    attribute: 'treatment_methods',
    position: 10
  }
]

export const POPULAR_TREATMENT_TERMS: PopularTreatmentItem[] = [
  ...popularTreatmentGroupA,
  ...popularTreatmentGroupB,
  ...popularTreatmentGroupC,
  ...popularTreatmentGroupD
]

export const popularTreatmentOptions = {
  Outpatient: {
    label: 'Outpatient Rehab Centers',
    description: 'Flexible addiction treatment'
  },
  Detox: {
    label: 'Detox Centers',
    description: 'Medically supervised inpatient care'
  },
  'Sober Living': {
    label: 'Sober Living Homes',
    description: 'Helps maintain your sobriety after rehab'
  },
  Adolescents: {
    label: 'Teen Rehabs',
    description: 'Teen treatment centers (ages 13 - 19)'
  },
  Veterans: {
    label: 'Rehabs for Veterans',
    description: "Rehab treating veterans' specific needs"
  },
  Executives: {
    label: 'Rehabs for Executives',
    description: 'Discreet and tailored rehab for executives'
  },
  'Insurance Accepted': {
    label: 'Insurance Accepted Rehabs',
    description: 'Find a rehab that accepts your insurance'
  },
  Christian: {
    label: 'Christian Rehab Centers',
    description: 'Rehab offering a Christian-based approach'
  },
  Wellness: {
    label: 'Wellness Treatment Centers',
    description: 'Treatment addressing overall well-being'
  }
}
